import { render, staticRenderFns } from "./DateDemo.vue?vue&type=template&id=47757118"
import script from "./DateDemo.vue?vue&type=script&lang=js"
export * from "./DateDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports